import { Mark } from 'tiptap';
import { toggleMark } from 'tiptap-commands';

export class TextColor extends Mark {
  get name() {
    return 'textcolor';
  }

  get defaultOptions() {
    return {
      color: ['red', 'green', 'blue', 'yellow'],
    };
  }

  get schema() {
    return {
      attrs: {
        color: {
          default: 'rgba(255,0,0,1)',
        },
      },
      parseDOM: ((this as unknown) as any).options.color.map((color) => ({
        tag: `span[style="color:${color}"]`,
        attrs: { color },
      })),
      toDOM: (node) => {
        return [
          'span',
          {
            style: `color:${node.attrs.color}`,
          },
          0,
        ];
      },
    };
  }

  public commands({ type }) {
    return (attrs) => toggleMark(type, attrs);
  }
}
